import React from 'react';

const Logo = () => {
  return (
    <div style={{ height: '100%', width: '30%' }}>
      <img
        style={{ height: '100%', width: '100%' }}
        alt="window world logo"
        src="/images/window-world-logo.png"
      />
    </div>
  );
};

export default Logo;
